/* src/app/components/chat-drawer/chat-drawer.component.scss */
.chat-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #031926;
  color: white;
  border: none;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s, right 0.3s ease;
}
.chat-fab:hover {
  transform: scale(1.1);
}
.chat-fab.active {
  background: #dc3545;
}
.chat-fab.shifted {
  right: 444px;
}
.chat-drawer {
  position: fixed;
  top: 0;
  right: -420px;
  width: 420px;
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease;
}
.chat-drawer.open {
  right: 0;
}
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #031926;
  color: white;
  font-weight: 600;
  font-size: 16px;
}
.chat-header .btn-clear {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  opacity: 0.7;
}
.chat-header .btn-clear:hover {
  opacity: 1;
}
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.chat-message {
  max-width: 85%;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}
.chat-message.user {
  align-self: flex-end;
  background: #031926;
  color: white;
  border-bottom-right-radius: 4px;
  white-space: pre-wrap;
}
.chat-message.assistant {
  align-self: flex-start;
  background: #f1f3f5;
  color: #212529;
  border-bottom-left-radius: 4px;
}
.markdown ::ng-deep p {
  margin: 0 0 8px 0;
}
.markdown ::ng-deep p:last-child {
  margin-bottom: 0;
}
.markdown ::ng-deep strong {
  font-weight: 600;
}
.markdown ::ng-deep ul,
.markdown ::ng-deep ol {
  margin: 4px 0;
  padding-left: 20px;
}
.markdown ::ng-deep li {
  margin-bottom: 2px;
}
.markdown ::ng-deep code {
  background: #e9ecef;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 12px;
}
.markdown ::ng-deep pre {
  background: #e9ecef;
  padding: 8px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 12px;
}
.markdown ::ng-deep pre code {
  background: none;
  padding: 0;
}
.markdown ::ng-deep h1,
.markdown ::ng-deep h2,
.markdown ::ng-deep h3,
.markdown ::ng-deep h4 {
  margin: 8px 0 4px 0;
  font-size: 14px;
  font-weight: 600;
}
.markdown ::ng-deep table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
  margin: 8px 0;
}
.markdown ::ng-deep table th,
.markdown ::ng-deep table td {
  border: 1px solid #dee2e6;
  padding: 4px 8px;
  text-align: left;
}
.markdown ::ng-deep table th {
  background: #e9ecef;
  font-weight: 600;
}
.tool-calls {
  margin-top: 8px;
}
.tool-calls details {
  margin-top: 4px;
  font-size: 12px;
}
.tool-calls details summary {
  cursor: pointer;
  color: #6c757d;
}
.tool-calls .tool-result {
  max-height: 150px;
  overflow: auto;
  background: #e9ecef;
  padding: 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-top: 4px;
  white-space: pre-wrap;
  word-break: break-all;
}
.typing {
  color: #6c757d;
  font-style: italic;
}
.chat-input {
  display: flex;
  padding: 12px 16px;
  border-top: 1px solid #dee2e6;
  gap: 8px;
}
.chat-input input {
  flex: 1;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
}
.chat-input input:focus {
  border-color: #031926;
}
.chat-input button {
  background: #031926;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
}
.chat-input button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=chat-drawer.component.css.map */
